// src/shared/components/EnhancedScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnimation } from 'framer-motion';

const EnhancedScrollToTop = ({
  behavior = 'smooth',
  delay = 300, // Wait for page transition to start
  preserveScrollOnBack = false, // Keep scroll position when using browser back button
}) => {
  const { pathname, key } = useLocation();
  const controls = useAnimation();

  useEffect(() => {
    // Check if this is a back/forward navigation
    const isBackForward =
      window.performance &&
      window.performance.navigation &&
      window.performance.navigation.type === 2;

    // Skip scroll-to-top for back/forward if preserveScrollOnBack is true
    if (preserveScrollOnBack && isBackForward) {
      return;
    }

    const scrollToTop = () => {
      // Smooth scroll to top
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior,
      });

      // Optional: Add a subtle animation indication
      controls.start({
        opacity: [0.5, 1],
        transition: { duration: 0.3 },
      });
    };

    // Add delay to ensure page transition has started
    const timer = setTimeout(scrollToTop, delay);

    return () => clearTimeout(timer);
  }, [pathname, key, behavior, delay, preserveScrollOnBack, controls]);

  return null;
};

export default EnhancedScrollToTop;
